module.exports = __webpack_public_path__ + "slack.f39dd1.svg";